

































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import CourtInstallation from "@/store/entities/booking/courtInstallation";
import Editor from "@tinymce/tinymce-vue";
import MultiPicture from "../../components/multi-picture.vue";
import RegionSelect from "../../components/region-select.vue";
import TinymceInit from "../../lib/TinymceInit";
import SinglePicture from "@/components/single-picture.vue";

TinymceInit.height = 300;
@Component({
  components: { Editor, RegionSelect, SinglePicture },
})
export default class CourtInstallationModel extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: false }) id: number;

  tinymceInit = TinymceInit;
  courtInstallation: CourtInstallation = new CourtInstallation();
  isAdd: boolean = false;
  pageTitle: string = "";
  get extData() {
    return {
      courtInstallation: this.courtInstallation.id,
    };
  }

  save() {
    (this.$refs.courtInstallationForm as any).validate(
      async (valid: boolean) => {
        console.log(valid, "valid");
        if (valid) {
          let type = `courtInstallation/${this.id > 0 ? "update" : "create"}`;
          await this.$store.dispatch({
            type: type,
            data: this.courtInstallation,
          });
          (this.$refs.courtInstallationForm as any).resetFields();

          this.$Message.success({
            content: this.id > 0 ? "修改成功" : "添加成功",
          });
          (this.$refs.courtInstallationForm as any).resetFields();
          this.$emit("save-success");
          this.$emit("input", false);
        }
      }
    );
  }
  cancel() {
    (this.$refs.courtInstallationForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      (this.$refs.courtInstallationForm as any).resetFields();

      this.$emit("input", value);
    } else {
      console.log(this.id);
      if (this.id > 0) {
        this.isAdd = false;
        this.courtInstallation = Util.extend(
          true,
          {},
          this.$store.state.courtInstallation.editCourtInstallation
        );
        console.log(this.courtInstallation, "courtInstallation");
      } else {
        this.isAdd = true;
      }
      this.pageTitle = this.isAdd ? "添加球场设施" : "编辑球场设施";
    }
  }
  courtInstallationRule = {
    name: [
      {
        required: true,
        message: "请输入名称",
        trigger: "blur",
      },
    ],
  };
}
